import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import { Link } from 'preact-router/match';
import { SendGAPageView } from '../../utils-and-data/utils.js';

class NotFound extends Component {
  componentDidMount() { 
    SendGAPageView({
      title: '404 page error',
      path: '/404'
    });
  }

  render() {
    return (
      <div styleName='not-found'>
      	<div className='inner'>
	        <h1>OOOPS</h1>
	        <p>WE LOOKED EVERYWHERE AND COULDN’T FIND THAT PAGE.</p>
	        <Link href='/'>START AGAIN</Link>
        </div>
      </div>
    )
  }
}

// Apply 'react-css-modules' to this react component:
export default CSSModules(NotFound, styles);



// WEBPACK FOOTER //
// ./app/frontend/components/routes/not-found.jsx